import React, {useState, useEffect} from 'react';
import {finishLoading, hideBookingBar, setError, showNavBar, startLoading} from "../../_store/_actions/uiActions";
import {useDispatch, useSelector} from "react-redux";
import {Background, UserData} from './style';
import {Button} from "react-bootstrap";
import {FaUserAlt} from "react-icons/fa";
import ProfileImage from "./ProfileImage";
import ContractInfo from "./ContractInfo";
import HttpClient from "../../_services/httpClient";
import SaveOnInfo from "./SaveOnInfo";
import {postData} from "../../_store/_actions/repositoryDataActions";
import {AlertError} from "../Login/style";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProfilePage = (props) => {

    const dispatch = useDispatch();
    const {msgError} = useSelector(state => state.ui);
    const {userName, partnerId} = useSelector(state => state.repository.user);
    const [userNameValue, setUserNameValue] = useState(userName);
    const [values, setValues] = useState([]);

    const notifySuccess = () => toast.success("The operation was applied correctly !", {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const handleUserNameChange = (e) => {
        setUserNameValue(e.value)
    }

    const handleInputChange = ({target}) => {
        setValues({
            ...values,
            [target.name]: target.value
        });
    }

    const getPartner = (url) => {
        return new Promise((resolve, eject) => {
            dispatch(startLoading());
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const findPartner = () => {
        getPartner(`/partner/ById/${partnerId}`).then(response => {
            if (response.status === 200) {
                setValues(response.data)
            }
        }).catch(error => {
        });
    }

    const handleUpdateUser = e => {
        e.preventDefault();

        if (isPersonalDataValid()) {
            const personalData = {
                PartnerId: values.partnerId,
                FirstName: values.firstName,
                LastName: values.lastName,
                Address: values.address,
                PostalCode: values.postalCode,
                City: values.city,
                State: values.state
            }

            dispatch(postData('/partner', personalData, props)).then(response => {
                if (response.status === 200) {
                    notifySuccess();
                }
            }).catch(error => {

            });
        }
    }

    const isPersonalDataValid = () => {
        if (values.firstName.trim().length === 0) {
            dispatch(setError('First name is required!'));
            return false
        }
        ;
        if (values.lastName.trim().length === 0) {
            dispatch(setError('Last name is required!'));
            return false
        }
        ;
        if (values.address.trim().length === 0) {
            dispatch(setError('Address is required!'));
            return false
        }
        ;
        if (values.city.trim().length === 0) {
            dispatch(setError('City name is required!'));
            return false
        }
        ;
        if (values.state.trim().length === 0) {
            dispatch(setError('State name is required!'));
            return false
        }
        ;
        if (values.postalCode.trim().length === 0) {
            dispatch(setError('Zip code name is required!'));
            return false
        }
        ;

        return true;
    }

    useEffect(() => {
        dispatch(showNavBar());
        dispatch(hideBookingBar());
        findPartner();
    }, [])

    return (
        <>
            <ToastContainer/>
            <Background className="clearfix">

                <h3 className="pl-3">User Profile</h3>
                <div className="row col-md-12 divcenter nopadding">

                    <div className="col-md-6 pb-4">
                        <ProfileImage/>
                    </div>

                    <div className="col-md-6">
                        <UserData>
                            <h5>Account ID:<span id="partner-folio"> {partnerId} </span></h5>
                            <div className="line nomargin pb-4"/>

                            {
                                msgError &&
                                <AlertError>
                                    {msgError}
                                </AlertError>
                            }

                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ContractInfo contractFolio={values.contractFolio}/>
                                    </div>

                                    <div className="col-md-6">
                                        <SaveOnInfo saveOnFolio={values.saveOnFolio}/>
                                    </div>
                                </div>

                                <div className="row pb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="profile-form-email">Email:</label>
                                        <input type="text" id="email1" readOnly
                                               name="email1"
                                               value={values.email1}
                                               onChange={handleInputChange}
                                               className="form-control not-dark"/>
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="profile-form-username">Username:</label>
                                        <input type="text" id="userName" readOnly
                                               name="userName"
                                               value={userNameValue}
                                               onChange={handleUserNameChange}
                                               className="form-control not-dark"/>
                                    </div>
                                </div>

                                <div className="row pb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="profile-form-email">First Name:</label>
                                        <input type="text" id="firstName"
                                               name="firstName"
                                               value={values.firstName ?? ''}
                                               onChange={handleInputChange}
                                               className="form-control not-dark"/>
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="profile-form-lastname">Last Name:</label>
                                        <input type="text" id="lastName"
                                               name="lastName"
                                               value={values.lastName ?? ''}
                                               onChange={handleInputChange}
                                               className="form-control not-dark"/>
                                    </div>
                                </div>

                                <div className="row pb-3">
                                    <div className="col-md-12">
                                        <label htmlFor="profile-form-address">Address:</label>
                                        <input type="text" id="address"
                                               name="address"
                                               value={values.address ?? ''}
                                               onChange={handleInputChange}
                                               className="form-control not-dark"/>
                                    </div>
                                </div>

                                <div className="row pb-3">
                                    <div className="col-md-4">
                                        <label htmlFor="profile-form-city">City:</label>
                                        <input type="text" id="city"
                                               name="city"
                                               value={values.city ?? ''}
                                               onChange={handleInputChange}
                                               className="form-control not-dark"/>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="profile-form-state">State:</label>
                                        <input type="text" id="state"
                                               name="state"
                                               value={values.state ?? ''}
                                               onChange={handleInputChange}
                                               className="form-control not-dark"/>
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="profile-form-zip">Zip:</label>
                                        <input type="text" id="postalCode"
                                               name="postalCode"
                                               value={values.postalCode ?? ''}
                                               onChange={handleInputChange}
                                               className="form-control not-dark"/>
                                    </div>
                                </div>


                                <div className="col_full nobottommargin">
                                    <Button type="submit" className="button button-3d button-blue nomargin"
                                            id="profile-form-submit"
                                            name="profile-form-submit"
                                            onClick={handleUpdateUser}
                                    ><FaUserAlt/> Update account
                                    </Button>
                                </div>


                            </div>
                        </UserData>
                    </div>

                </div>
            </Background>
        </>
    )
}

export default ProfilePage;